import React from "react";

const Logo = ({ style }) => {
    return <img alt='jetbidders' src="transparent-logo-100.png" style={{ width: 'auto', height: 'auto', ...style }} />

}

export default Logo;